import {BaseCard} from "../../Components/Cards/BaseCard";
import {useEffect, useState} from "react";
import {useBoundStore} from "../../Store/store";
import * as React from "react";
import {useNavigate, useParams} from "react-router-dom";
import {faUser} from "@fortawesome/free-solid-svg-icons";
import {IconInputCard} from "../../Components/Cards/IconInputCard";
import {ShiftInfoCard} from "../../Components/Cards/ShiftInfoCard";
import Star from "../../Assets/images/star.svg";
import {PrimaryButton} from "../../Components/Buttons/PrimaryButton";
import {DangerButton} from "../../Components/Buttons/DangerButton";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import {isMyCcpSubdomain} from "../../Utils/SubdomainHelper";
import {useTranslation} from "react-i18next";

export const ShiftApplicationsResponse = () => {
    const {t} = useTranslation();
    const {
        shiftId,
        applicationId
    } = useParams();
    const navigate = useNavigate();

    const getShiftDetail = useBoundStore((state) => state.getShiftDetail);
    const shiftDetail = useBoundStore((state) => state.shiftDetail);
    const acceptApplication = useBoundStore((state) => state.acceptApplication);
    const rejectApplication = useBoundStore((state) => state.rejectApplication);

    const [application, setApplication] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const jobFunctions = [
        {value: 'A1', label: t('functions.A1'), id: 0},
        {value: 'A2', label: t('functions.A2'), id: 1},
        {value: 'A0', label: t('functions.A0'), id: 2},
        {value: 'A3', label: t('functions.A3'), id: 3}
    ]

    useEffect(() => {
        setIsLoading(true);
        getShiftDetail(shiftId).finally(() => {
            setIsLoading(false);
        });
    }, [getShiftDetail, shiftId, applicationId]);

    useEffect(() => {
        if (shiftDetail && shiftDetail.applications) {
            setApplication(shiftDetail?.applications?.find(application => application.id === parseInt(applicationId)));
        }
    }, [shiftDetail, applicationId]);

    const getTextForHourlyRate = () => {
        const getHourlyRate = () => {
            const rate = application?.freelancer?.hourly_rate;
            return rate && !isNaN(Number(rate)) ? Number(rate) : 0;
        };

        const formatRate = (rate) => {
            return Number(rate).toFixed(2).replace('.', ',');
        };

        if (shiftDetail?.branch?.max_hourly_rate_vk && Number(shiftDetail.branch.max_hourly_rate_vk) > 0 && ['A1','A2'].includes(application?.freelancer?.function)) {
            let freelancerHourlyRate = getHourlyRate();
            if(freelancerHourlyRate > shiftDetail.branch.max_hourly_rate_vk) {
                freelancerHourlyRate = shiftDetail.branch.max_hourly_rate_vk;
            }

            const displayRate = isMyCcpSubdomain() ? freelancerHourlyRate : freelancerHourlyRate * 1.18;
            return t('shifts.hourly_rate_capped', {max: shiftDetail.branch.max_hourly_rate_vk, label: isMyCcpSubdomain() ? t('shifts.hourly_rate_label_internal') : t('shifts.hourly_rate_label_external'), rate: formatRate(displayRate)});
        }

        if (shiftDetail?.branch?.max_hourly_rate_zk && Number(shiftDetail.branch.max_hourly_rate_zk) > 0 && ['A0','A3'].includes(application?.freelancer?.function)) {
            let freelancerHourlyRate = getHourlyRate();
            if(freelancerHourlyRate > shiftDetail.branch.max_hourly_rate_zk) {
                freelancerHourlyRate = shiftDetail.branch.max_hourly_rate_zk;
            }

            const displayRate = isMyCcpSubdomain() ? freelancerHourlyRate : freelancerHourlyRate * 1.18;
            return t('shifts.hourly_rate_capped', {max: shiftDetail.branch.max_hourly_rate_zk, label: isMyCcpSubdomain() ? t('shifts.hourly_rate_label_internal') : t('shifts.hourly_rate_label_external'), rate: formatRate(displayRate)});
        }

        const hourlyRate = getHourlyRate();
        if (hourlyRate === 0) {
            return t('shifts.rate_unavailable');
        }

        const displayRate = isMyCcpSubdomain() ? hourlyRate : hourlyRate * 1.18;
        return t('shifts.hourly_rate_simple', {rate: formatRate(displayRate)});
    }

    if (isLoading) {
        return (
            <div>
                <div>
                    <div className={'flex flex-row justify-between'}>
                        <h1 className={'text-2xl font-semibold'}>{t('shifts.applications_title')}</h1>
                    </div>
                </div>
                <div className={'grid grid-cols-1 md:grid-cols-3 md:space-x-4 space-y-4 md:space-y-0'}>
                    <BaseCard border={false} className={'md:col-span-2'}>
                        <div className="flex flex-col items-center justify-center py-16">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
                            <p className="mt-4 text-gray-500">{t('general.messages.loading')}</p>
                        </div>
                    </BaseCard>
                    <BaseCard border={false}>
                        <div className="flex items-center justify-center py-16">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
                        </div>
                    </BaseCard>
                </div>
            </div>
        );
    }

    return (
        <div>
            <div>
                <div className={'flex flex-row justify-between'}>
                    <h1 className={'text-2xl font-semibold'}>{t('shifts.applications_title')}</h1>
                </div>
            </div>
            <div className={'grid grid-cols-1 md:grid-cols-3 md:space-x-4 space-y-4 md:space-y-0'}>
                <BaseCard border={false} className={'md:col-span-2'}>
                    <IconInputCard
                        icon={faUser}
                        isImage={true}
                        onClick={() => {}}
                        showArrow={false}
                    >
                        <div className={'flex flex-row justify-between'}>
                            <div>
                                <p className={'text-lg text-gray-500'}>{application?.freelancer?.first_name} {application?.freelancer?.last_name}</p>
                                <p className={'text-sm'}>{jobFunctions.find(func => application?.freelancer?.function === func.value)?.label}</p>
                                {application?.applied_as_statuut && application.applied_as_statuut !== 'freelance' ? (
                                    <p className={'text-xs text-purple-800 bg-purple-50 inline-block px-2 py-0.5 rounded mt-1'}>
                                        {t('applications_module.pratoflex_note', {statuut: t(`statuten.${application.applied_as_statuut}`)})}
                                    </p>
                                ) : (
                                    <p className={'text-sm'}>{getTextForHourlyRate()}</p>
                                )}
                            </div>
                            <div>
                                <div className={'flex flex-row-reverse gap-1'}>
                                    <img src={Star} alt={'star icon'} className={'w-full max-h-8'}/>
                                    <p className={'text-xl my-auto pr-4 text-gold'}>{application?.freelancer?.average_rating ?? '-'}</p>
                                </div>
                            </div>
                        </div>
                    </IconInputCard>

                    <div className={'flex flex-row justify-end'}>
                        <div className={'flex flex-row justify-between mt-4 w-max items-center'}>
                            <div className={'mr-4'}>
                                <DangerButton
                                    className={"mr-4"}
                                    onClick={() => {
                                        rejectApplication(shiftId, application?.freelancer?.id)
                                            .then(() => {
                                                toast.success(t('applications_module.toast_rejected'));
                                                navigate('/customer/shifts?date=' + dayjs(shiftDetail?.start_time).unix());
                                            })
                                            .catch((error) => {
                                                console.error('Error rejecting application:', error);
                                            });
                                    }}
                                >
                                    {t('general.actions.reject')}
                                </DangerButton>
                            </div>
                            <div>
                                <PrimaryButton
                                    className={'mr-4 group'}
                                    onClick={() => {
                                        setSubmitting(true);
                                        acceptApplication(shiftId, application?.freelancer?.id)
                                            .then(() => {
                                                toast.success(t('applications_module.toast_accepted'));
                                                navigate('/customer/shifts?date=' + dayjs(shiftDetail?.start_time).unix());
                                            })
                                            .catch((error) => {
                                                console.error('Error accepting application:', error);
                                            })
                                            .finally(() => {
                                                setSubmitting(false);
                                            });
                                    }}
                                    disabled={submitting}
                                >
                                    {
                                        submitting && (
                                            <div className={'flex flex-row justify-center items-center'}>
                                                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white group-hover:border-primary"></div>
                                            </div>
                                        )
                                    }

                                    {
                                        !submitting && t('general.actions.accept')
                                    }
                                </PrimaryButton>
                            </div>
                        </div>
                    </div>

                </BaseCard>

                <BaseCard border={false}>
                    <ShiftInfoCard shift={shiftDetail}/>
                </BaseCard>
            </div>


        </div>
    )
}